module.exports = __webpack_public_path__ + "img/ignis-glx-fenix.093dcf7c.png";